<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <ng-container *ngIf="giftCard && !isLoadingGiftCard">


    <div fxFlex="50">
      <button class="mr-2" mat-raised-button color="basic" (click)="returnBack()">Back</button>


    </div>
    <div fxFlex="50" style="text-align: right">

    </div>


  </ng-container>
</div>

<div class="content-card" fxLayout="row wrap" fxLayoutGap="10px">

  <!-- #region order details -->




  <mat-card class="container-md" style="min-width: 400px">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoadingGiftCard" class="progress-bar"></mat-progress-bar>
    <mat-card-header fxLayout="row" fxLayoutGap="10px">
      <mat-card-title>

        <div fxLayout="row" style="">

          <div fxFlex="30">
            <img src="{{giftCard.brand.logoUrl}}" style="width: 100%; max-width: 140px; margin-right: 10px;" alt="Brand Logo" />
          </div>
          <div fxFlex="70">
            <h5>Gift card<br />{{ giftCard?.brand?.name }} (#{{giftCard?.id}})</h5>

          </div>
        </div>




      </mat-card-title>
      <div fxFlex></div>
      <div>

        <!--
        <span *ngIf="false && order && order.webIdTransaction" style="margin-right: 10px;">
          <button mat-raised-button class="mr-1" color="blue" [disabled]="isResendWebidDisabled() && (order.webIdTransaction.status === 1)" (click)="resendWebIdLink(order)">Resend WebID</button>
        </span>-->


      </div>
    </mat-card-header>
    <mat-card-content class="mt-2">

      <span class="mr-2" *ngIf="!giftCard && !isLoadingGiftCard">Gift card not exist/or has been removed</span>
      <span class="mr-2" *ngIf="isLoadingGiftCard">Loading data...</span>
      <div *ngIf="giftCard">


        <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
          <app-content-row [field]="field" [entity]="giftCard"></app-content-row>
        </div>

      </div>
    </mat-card-content>
    <mat-card-actions align="end" class="mt-2">

    </mat-card-actions>
  </mat-card>

  <div fxFlex="50">

    <mat-card class="container-md" style="min-width: 400px">
      <mat-progress-bar mode="indeterminate" *ngIf="isLoadingCustomer" class="progress-bar"></mat-progress-bar>
      <mat-card-header fxLayout="row" fxLayoutGap="10px">
        <mat-card-title>

          <h5>{{ customer?.firstName }} {{ customer?.lastName }}</h5>


        </mat-card-title>
        <div fxFlex></div>
        <div>

          <!--
          <span *ngIf="false && order && order.webIdTransaction" style="margin-right: 10px;">
            <button mat-raised-button class="mr-1" color="blue" [disabled]="isResendWebidDisabled() && (order.webIdTransaction.status === 1)" (click)="resendWebIdLink(order)">Resend WebID</button>
          </span>-->


        </div>
      </mat-card-header>
      <mat-card-content class="mt-2">

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
          <app-content-row [field]="field" [entity]="customer"></app-content-row>
        </div>
      </mat-card-content>
    </mat-card>


    <div style="height: 20px;"></div>


        <mat-accordion class="" *ngIf="!isLoadingCards">
          <mat-expansion-panel disabled=true>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Card
              </mat-panel-title>
              <mat-panel-title>
                Token
              </mat-panel-title>
              <mat-panel-title>
                Last 4
              </mat-panel-title>
              <mat-panel-title>
                Exp.
              </mat-panel-title>

              <mat-panel-title>
                Status
              </mat-panel-title>
              <!--<mat-panel-title>
                Last Payment Reminder
              </mat-panel-title>-->
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel *ngFor="let card of customerCards">
            <mat-expansion-panel-header>
              <mat-panel-title>
                  <span *ngIf="card.gpsCardStatus" [matTooltip]="gpsCardStatusHelper.getText(card.gpsCardStatus)" style="margin-right: 5px;">
                    {{ gpsCardStatusHelper.getIcon(card.gpsCardStatus) }}
                  </span>
                {{card.product.internalName}}
                <span [style.background-color]="'#'+card.displayColor" style="margin-left: 5px; border-radius: 3px; padding: 2px; width: 15px; height: 15px; ">
                    &nbsp;
                  </span>
              </mat-panel-title>
              <mat-panel-title>
                {{card.token}}

                <span *ngIf="card.status !== 6 && card.usageStatus == cardUsageStatus.dormant" [matTooltip]="'Dormant card'">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">💤</div>
                  </span>


                <span *ngIf="card.primaryCardId" [matTooltip]="'Linked to ' + card.primaryToken">
                    <div style="height: 20px; width: 20px; margin-right: 3px; text-align: center">⛓</div>
                  </span>

              </mat-panel-title>
              <mat-panel-title>
                  <span *ngIf="card.maskedPAN">
                    *{{card.maskedPAN.substring(12) }}
                  </span>
              </mat-panel-title>
              <mat-panel-title>
                {{card.expireDate | date: 'MM/yy'}}
              </mat-panel-title>

              <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
                <span *ngIf="card.status == 6">⛔️ </span>
                {{card.statusName}}<div style="display: inline-block; margin-left: 4px; padding: 3px; background-color: dodgerblue; color: black; font-size: .8em;" *ngIf="card.reorderReason">R</div>
              </mat-panel-title>
              <!--<mat-panel-title>
                {{cardContainer.card.order.paymentEmailReminders && cardContainer.card.order.paymentEmailReminders[cardContainer.card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
              </mat-panel-title>-->
            </mat-expansion-panel-header>

            <div style="padding: 3px;">
              <span style="margin: 5px; padding: 3px; background-color: #bbe4fd; border-radius: 5px;" *ngIf="card.primaryCardId">Linked to {{ card.primaryToken }}</span>
              <span style="margin: 5px; padding: 3px; background-color: #bbe4fd; border-radius: 5px;" *ngIf="card.isVirtualOnly">This card is virtual only</span>
            </div>

            <div class="list-item" fxLayout="row" *ngFor="let field of cardFields">
              <app-content-row [field]="field" [entity]="card"></app-content-row>

            </div>



            <div *ngIf="card.isQueuedForConversion" style="background-color: #c6e589; font-size: .8em; padding: 5px; margin-top: 5px;">
              This card is queued to be converted to physical
            </div>


            <mat-card-actions align="end" >

            </mat-card-actions>




          </mat-expansion-panel>
        </mat-accordion>


    </div>

  </div>

